import React from 'react';
import { useTranslation } from 'react-i18next';
import { Switch } from '@progress/kendo-react-inputs';
import { SkeletonButton } from 'app/components/skeletons';
import { calculateAnnualSavings } from './utils';
import './BillingSwitch.less';
import {
  BillingPeriod,
  PlanPricing,
} from 'app/components/subscriptions/dialogs/ManageYourPlanDialog/types';

interface Props {
  billingPeriod: BillingPeriod;
  planPricing?: PlanPricing;
  isLoading: boolean;
  setBillingPeriod: (period: BillingPeriod) => void;
}

export default function BillingSwitch({
  billingPeriod,
  planPricing,
  isLoading,
  setBillingPeriod,
}: Props) {
  const { t } = useTranslation();

  const isAnnuallyBilling = billingPeriod === 'annually';

  return (
    <div className="billing-switch">
      <h3 className="billing-switch__title">
        {t(
          'subscriptions.manage_your_plan.premium_telematics_plan.billing_selection.title',
        )}
      </h3>

      <div className="billing-switch__toggle">
        <span>
          {t(
            'subscriptions.manage_your_plan.premium_telematics_plan.billing_selection.bill_monthly',
          )}
        </span>
        <Switch
          onLabel=""
          offLabel=""
          checked={isAnnuallyBilling}
          onChange={() =>
            setBillingPeriod(isAnnuallyBilling ? 'monthly' : 'annually')
          }
        />
        <span>
          {t(
            'subscriptions.manage_your_plan.premium_telematics_plan.billing_selection.bill_annually',
          )}
        </span>
        {isLoading ? (
          <SkeletonButton className="billing-switch__discount-chip-skeleton" />
        ) : (
          <span className="billing-switch__discount-chip">
            {t(
              'subscriptions.manage_your_plan.premium_telematics_plan.billing_selection.discount',
              {
                percent: planPricing
                  ? calculateAnnualSavings(
                      planPricing.monthly.amount,
                      planPricing.annually.amount,
                    )
                  : 0,
              },
            )}
          </span>
        )}
      </div>
    </div>
  );
}
